import React from 'react';
import LineItemsTable from './LineItemsTable';

const LineItemsTableContainer = ({ ...props }) => {
  const handleDeleteItemClick = (rowIndex, { values, setFieldValue }) => {
    const newItems = values.items?.filter((_, index) => index !== rowIndex);
    setFieldValue('items', newItems);
  };

  return (
    <LineItemsTable {...props} onDeleteItemClick={handleDeleteItemClick} />
  );
};

export default React.memo(LineItemsTableContainer);
